const MAX_AGE_OF_VEHICLES = 8;

/**
 * Builds a query to send to Algolia to find cars that have the passed safety feature.
 * It intentionally requests more results than we need to display so that we can randomise results on the client side.
 *
 * Business rules for the search are:
 *  - Must have safety feature
 *  - 5 star safety rating
 *  - No older than 8 years
 *  - No light vehicles
 *
 * @param {object} safetyFeature Safety feature being represented on the page
 */
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'safetyFeature' implicitly has an 'any' type.
const buildQuery = (safetyFeature) => {
  const safetyFeatureCode = safetyFeature.tacFeatureCode;
  const safetyFeatureQuery = `standardTacFeatureCodes:${safetyFeatureCode}`;

  const currentYear = new Date().getFullYear();
  const yearQuery = `year > ${currentYear - MAX_AGE_OF_VEHICLES}`;

  const ratingQuery = `stars:5 AND NOT ratingBy:null`;

  const segmentQuery = `(NOT segment:Micro AND NOT segment:Light)`;

  const query = [`isRecommendable:true`, safetyFeatureQuery, ratingQuery, segmentQuery, yearQuery].join(' AND ');

  return query;
};

export default buildQuery;
export { MAX_AGE_OF_VEHICLES };
